/**
 * GlassInteractionPanel — Premium glassmorphic container
 * 
 * The main interaction surface that floats over the wallpaper.
 * Large rounded corners, controlled transparency, subtle border glow.
 */
import React from 'react';

export default function GlassInteractionPanel({ children, className = '' }) {
  return (
    <div
      className={`
        w-full rounded-3xl overflow-hidden
        bg-slate-900/70 backdrop-blur-xl
        border border-white/10
        shadow-2xl shadow-black/40
        ${className}
      `}
      style={{
        boxShadow: '0 0 40px rgba(0,0,0,0.4), 0 0 80px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.06)',
      }}
    >
      {children}
    </div>
  );
}
